<script lang="ts" module>
	export interface TableCellProps {
		textVariant?: TxtVariant;
		dataCy: string;
		content?: string | number | undefined | null;
		width?: string | undefined;
		classes?: { text?: string };
		wrap?: boolean | undefined;
		class?: string;
		onclick?: (e: MouseEvent) => void;
		custom?: import('svelte').Snippet;
		children?: import('svelte').Snippet;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { Tooltip } from '../../Tooltip';
	import { Txt, type TxtVariant } from '../../Txt';

	let {
		textVariant = 'body2',
		dataCy,
		content = undefined,
		width = undefined,
		classes = {},
		wrap = false,
		custom,
		children,
		onclick,
		...rest
	}: TableCellProps = $props();

	let ref: HTMLParagraphElement | undefined = $state();
	let showTooltip: boolean | undefined = $state();

	$effect(() => {
		if (showTooltip === undefined && ref) {
			showTooltip = ref?.scrollWidth !== ref?.clientWidth;
		}
	});
</script>

<td
	class={twMerge('border-b border-gray-200 px-3 py-2', rest.class)}
	style={width ? `width: ${width};` : undefined}
	data-cy={`${dataCy}-cell`}
	{onclick}
>
	{#if custom}
		{@render custom?.()}
	{:else if showTooltip && content}
		<Tooltip dataCy={`${dataCy}-cell`} content={`${content}`} class="max-w-full translate-y-[3px]">
			<Txt variant={textVariant} component="div" class={classNames('max-w-full', classes?.text)}>
				<p
					class={classNames('max-w-full', {
						'overflow-hidden text-ellipsis whitespace-nowrap': !wrap
					})}
				>
					{@render children?.()}
				</p>
			</Txt>
		</Tooltip>
	{:else}
		<Txt variant={textVariant} component="div" class={classNames('max-w-full', classes?.text)}>
			<p
				bind:this={ref}
				class={classNames('max-w-full', {
					'overflow-hidden text-ellipsis whitespace-nowrap': !wrap
				})}
			>
				{@render children?.()}
			</p>
		</Txt>
	{/if}
</td>
